<template>
  <div class="settle-accounts-detail">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :isQueryPanel="false"
            :rules="baseFormRules"
            labelWidth="160px"
            @changeCompanyHandler="changeCompanyHandler"
            @changeDepartmentHandler="changeDepartmentHandler"
            @changeCurrencyHandler="changeCurrencyHandler"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            费用汇总
          </div>
        </template>
        <div class="collapse-content">
          <CostAggregation
            ref="linesRef"
            :isCreate="isCreate"
            :linesData="detailData"
            :contractNo="this.baseFormData.contractNo"
            :serviceType="this.baseFormData.serviceType"
            :expenseType="this.baseFormData.expenseType"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="3" v-if="_abnormalExpenseFlag != '1'">
        <!-- v-if="_confirmStatus == '01'" -->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            业务执行明细
          </div>
        </template>
        <div class="collapse-content">
          <!-- <div v-if="_confirmStatus == '01'">
            <el-button type="primary" @click="importDetailsHandler()"> 引入执行明细 </el-button>
            <el-button type="danger" @click="_deleteHandler()"> 删除 </el-button>
          </div> -->
          <CommonTransportation
            v-if="serviceTypeShow == '0' && commonTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="普通运输"
            :preSettlements="commonTransportationDataList"
          />
          <CommonTransportation
            v-if="serviceTypeShow == '1' && truckTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="集卡运输"
            marked="集卡运输"
            :preSettlements="truckTransportationDataList"
          />
          <!-- <TruckTransportation
            v-if="serviceTypeShow == '1' && truckTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            :preSettlements="truckTransportationDataList"
          /> -->
          <PublickTransport
            v-if="serviceTypeShow == '2' && highWayTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="公路装卸"
            :preSettlements="highWayTransportationDataList"
          />
          <PublickTransport
            v-if="serviceTypeShow == '3' && consultTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="咨询服务"
            :preSettlements="consultTransportationDataList"
          />
          <PublickTransport
            v-if="serviceTypeShow == '4' && storageTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="仓储服务"
            :preSettlements="storageTransportationDataList"
          />
          <PublickTransport
            v-if="serviceTypeShow == '5' && superviseTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="监管服务"
            :preSettlements="superviseTransportationDataList"
          />
          <PublickTransport
            v-if="serviceTypeShow == '7' && railWayLoadTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="铁路装卸服务"
            :preSettlements="railWayLoadTransportationDataList"
          />
          <RailwayTransportation
            v-if="serviceTypeShow == '6' && railWayTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            :preSettlements="railWayTransportationDataList"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div style="display: flex; justify-content: center" v-if="_confirmStatus == '01'"
      ><el-button type="primary" @click="confirmHandler()"> 草稿确认 </el-button></div
    >
  </div>
</template>

<script>
  import CostAggregation from './components/CostAggregation/index.vue';
  import CommonTransportation from './components/CommonTransportation/index.vue';
  // import TruckTransportation from './components/TruckTransportation/index.vue';
  import PublickTransport from './components/PublickTransport/index.vue';
  import RailwayTransportation from './components/RailwayTransportation/index.vue';

  import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';
  import baseInfoMixin from './components/BaseInfo/index.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import { tableList } from './components/CommonTransportation/index.js';
  // import SALE_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  export default {
    components: {
      CostAggregation,
      CommonTransportation,
      // TruckTransportation,
      PublickTransport,
      RailwayTransportation,

      SiruiSearch,
    },
    name: 'multimodalTransportExpenseListYSDetail',
    mixins: [baseInfoMixin],
    data() {
      return {
        activeNames: ['1', '2', '3', '4', '5', '6'],
        baseFormData: {},
        content: '',
        currentSettleAccountRowData: null, // 当前选中的行数据
        costAggregationList: [], // 全部的行数据
        settleAccountsDetailMap: new Map(), // key为结算行的id,值为结算明细数组
        currentSettleAccountDetailList: tableList, //明细表数据
        currentStatus: '',
        currentDetailData: {}, // 当前结算明细数据
        statementStatus: '', // 结算单状态
        statementIssueStatus: '', // 开票状态
        detailData: [], // 根据id查询出来的数据
        serviceTypeShow: '',
        commonTransportationDataList: [], //普通公路
        truckTransportationDataList: [], //集卡运输
        highWayTransportationDataList: [], //公路装卸
        consultTransportationDataList: [], //咨询服务
        storageTransportationDataList: [], //仓储服务
        superviseTransportationDataList: [], //监管服务
        railWayLoadTransportationDataList: [], //铁路装卸服务
        railWayTransportationDataList: [], //铁路运输服务
      };
    },

    methods: {
      //引入执行明细
      importDetailsHandler() {
        let serviceType = this.$route.query?.serviceType;
        if (['0', '1'].includes(serviceType)) {
          this._importOrdinaryTruckHandler(serviceType);
        } else {
          this._importPublickTransportHandler(serviceType);
        }
        console.log('引入执行明细');
        console.log(this.detailData[0], ' this.instructCode');
      },
      async _importOrdinaryTruckHandler(serviceType) {
        let postData = { instructCode: this.detailData[0].instructionNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.ORDINARY_TRUCK_QUERY_API,
          postData
        );
        console.log(data, '执行明细');
        if (data.code === 0) {
          if (serviceType == '0') {
            this.serviceTypeShow = serviceType;
            this.commonTransportationDataList = data.data.orderTrackings;
          }
          if (serviceType == '1') {
            this.serviceTypeShow = serviceType;
            this.truckTransportationDataList = data.data.orderTrackings;
          }
        } else {
          this.$message.error(`${data.msg}`);
        }
      },
      async _importPublickTransportHandler(serviceType) {
        let postData = { instructCode: this.detailData[0].instructionNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.PUBLIC_TRANSPORT_QUERY_API,
          postData
        );
        console.log(data, '执行明细', serviceType);

        if (data.code === 0) {
          let {
            instructCode,
            purchaseOrgName,
            serviceProviderName,
            instructStatus,
            instructStatusName,
            instructIssueDate,
            instructUpdateDate,
            businessComplatedDate,
          } = data.data;
          let publicList = [];
          publicList.push({
            instructCode,
            purchaseOrgName,
            serviceProviderName,
            instructStatusName,
            instructStatus,
            instructIssueDate,
            instructUpdateDate,
            businessComplatedDate,
          });
          console.log(serviceType);
          if (serviceType == '2') {
            this.serviceTypeShow = serviceType;
            console.log(publicList, 'publicList');
            this.highWayTransportationDataList = publicList;
          }
          if (serviceType == '3') {
            this.serviceTypeShow = serviceType;
            this.consultTransportationDataList = publicList;
          }
          if (serviceType == '4') {
            this.serviceTypeShow = serviceType;
            this.storageTransportationDataList = publicList;
          }
          if (serviceType == '5') {
            this.serviceTypeShow = serviceType;
            this.superviseTransportationDataList = publicList;
          }
          if (serviceType == '6') {
            this.serviceTypeShow = serviceType;
            this.railWayTransportationDataList = data.data.truckContainers || [];
          }
          if (serviceType == '7') {
            this.serviceTypeShow = serviceType;
            this.railWayLoadTransportationDataList = publicList;
          }
        } else {
          this.$message.error(`${data.msg}`);
        }
      },
      //删除操作
      _deleteHandler() {
        if (!this.$refs.instructionExecutionDetails?.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$refs.instructionExecutionDetails.deleteBtnClickHandler();
            this.$refs.instructionExecutionDetails.selectionList = [];
            this.$message.success('删除成功');
          })
          .catch(() => {});

        // setTimeout(() => {
        //   console.log(
        //     this.$refs.instructionExecutionDetails.getTableData(),
        //     'this.$refs.instructionExecutionDetails.getTableData()'
        //   );
        // }, 100);
      },
      //草稿确认
      async confirmHandler() {
        // console.log('草稿确认');
        // console.log(this.$refs.linesRef.getTableData(), 'this.$refs.linesRef.getTableData()');
        let tableData = this.$refs?.linesRef?.getTableData()[0];
        let orderTrackings = null;
        let orderTransportInstruct = null;
        let tableDataTransport = this.$refs?.instructionExecutionDetails?.getTableData() || [];
        console.log(tableDataTransport, 'tableDataTransporttableDataTransporttableDataTransport');
        if (['0', '1'].includes(this.$route.query?.serviceType)) {
          orderTrackings = tableDataTransport;
          orderTrackings.map((item) => {
            this.$set(item, 'expenseNo', this.baseFormData.expenseNo);
          });
        }
        if (['2', '3', '4', '5', '7'].includes(this.$route.query?.serviceType)) {
          orderTransportInstruct = {
            ...tableDataTransport[0],
            expenseNo: this.baseFormData.expenseNo,
          };
        }
        if (['6'].includes(this.$route.query?.serviceType)) {
          orderTransportInstruct = {
            expenseNo: this.baseFormData.expenseNo,
            truckContainer: JSON.stringify(tableDataTransport),
          };
        }

        let {
          expenseType,
          expenseTypeName,
          // contractNo,
          instructionNo,
          multiBillingRuleFlag,
          originalPrice,
          statementQuantity,
          unit,
          originalAmount,
          exchangeRate,
          domesticAmount,
          adjustOriginalPrice,
          adjustStatementQuantity,
          adjustOriginalAmount,
          adjustDomesticAmount,
          adjustReason,
        } = tableData;
        let postData = {
          confirmStatus: '02',
          id: this.$route.query?.id,
          expenseType,
          expenseTypeName,
          contractNo: this.baseFormData.contractNo,
          instructionNo,
          multiBillingRuleFlag,
          originalPrice,
          statementQuantity,
          unit,
          originalAmount,
          exchangeRate,
          domesticAmount,
          adjustOriginalPrice,
          adjustStatementQuantity,
          adjustOriginalAmount,
          adjustDomesticAmount,
          adjustReason,
          orderTrackings,
          orderTransportInstruct,
        };
        // console.log('草稿确认', postData);
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.RECEIVABLESEXPENSE_DETAIL_ENABLE_API,
          postData
        );
        if (data.code === 0) {
          this.$message.success('操作成功！');
          this.$router.go(-1);
        } else {
          this.$message.error(`${data.msg}`);
        }
      },
      // 根据id来查下数据
      async _getDetailDataById(id) {
        if (!id) return;
        this.loading.startLoading();
        const { data } = await this.$axios.post(
          `${RECEIVABLES_MULTIMODALTRANSPORT.RECEIVABLESEXPENSE_QUERY_BY_ID}/${id}`
        );
        console.log(data, 'data99999');
        if (data.code == 0) {
          this.loading.endLoading();
          let {
            businessCompanyName,
            businessDepartmentName,
            customerName,
            customerNo,
            productType,
            serviceType,
            createMethod,
            expenseType,
            expenseTypeName,
            accountPeriod,
            expenseGenerationDate,
            instructionIssueDate,
            confirmStatus,
            businessDocCode,
            orderCode,
            expenseNo,
            contractNo,
            abnormalExpenseFlag,
            currencyCode,
            currencyName,
            exchangeRate,
            processStatus,
            salesmanNo,
            salesmanName,
            settlementNo,
          } = data.data;
          this.baseFormData = {
            businessCompanyName,
            businessDepartmentName,
            customerName,
            customerNo,
            productType,
            serviceType,
            createMethod,
            expenseType,
            expenseTypeName,
            accountPeriod,
            expenseGenerationDate,
            instructionIssueDate,
            confirmStatus,
            businessDocCode,
            orderCode,
            expenseNo,
            contractNo,
            abnormalExpenseFlag: abnormalExpenseFlag + '',
            currencyCode,
            currencyName,
            exchangeRate,
            processStatus: processStatus + '',
            salesmanNo,
            salesmanName,
            settlementNo,
          };
          console.log(abnormalExpenseFlag, 'abnormalExpenseFlag99999');
          let {
            instructionNo,
            multiBillingRuleFlag,
            originalPrice,
            statementQuantity,
            unit,
            unitName,
            originalAmount,
            domesticAmount,
            adjustOriginalPrice,
            adjustStatementQuantity,
            adjustOriginalAmount,
            adjustDomesticAmount,
            adjustReason,
            exceptionCode,
            billingRuleContractNo,
          } = data.data;
          this.detailData.push({
            abnormalExpenseFlag,
            exceptionCode,
            expenseType,
            expenseTypeName,
            // contractNo: abnormalExpenseFlag == 1 ? '' : contractNo,
            contractNo,
            billingRuleContractNo,
            instructionNo,
            multiBillingRuleFlag: abnormalExpenseFlag == 1 ? '' : multiBillingRuleFlag,
            originalPrice,
            statementQuantity,
            unit,
            unitName,
            originalAmount,
            exchangeRate: exchangeRate ? exchangeRate : '1',
            domesticAmount,
            adjustOriginalPrice,
            adjustStatementQuantity,
            adjustOriginalAmount,
            adjustDomesticAmount,
            adjustReason,
          });
          if (['02'].includes(this.currentStatus)) {
            if (['0', '1'].includes(serviceType)) {
              this._importOrdinaryTruckDetailHandler(serviceType, expenseNo);
            } else {
              this._importPublickTransportDetailHandler(serviceType, expenseNo);
            }
          }
          this.importDetailsHandler();
        } else {
          this.$message.error(`${data.msg}`);
        }
      },
      async _importOrdinaryTruckDetailHandler(serviceType, expenseNo) {
        let postData = { expenseNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.ORDINARY_TRUCK_QUERY_DETAIL_API,
          postData
        );
        console.log(data, '执行明细');
        if (data.code === 0) {
          if (serviceType == '0') {
            this.serviceTypeShow = serviceType;
            console.log(data.data, 'data.data');
            this.commonTransportationDataList = data.data;
          }
          if (serviceType == '1') {
            this.serviceTypeShow = serviceType;
            console.log(data.data, 'data.data');
            this.truckTransportationDataList = data.data;
          }
        } else {
          this.$message.error(`${data.msg}`);
        }
      },
      async _importPublickTransportDetailHandler(serviceType, expenseNo) {
        let postData = { expenseNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.PUBLIC_TRANSPORT_QUERY_DETAIL_API,
          postData
        );
        console.log(data, '执行明细', serviceType);

        if (data.code === 0) {
          if (data.data.length) {
            let {
              instructCode,
              purchaseOrgName,
              serviceProviderName,
              instructStatus,
              instructStatusName,
              instructIssueDate,
              instructUpdateDate,
              businessComplatedDate,
            } = data.data[0];
            let publicList = [];
            publicList.push({
              instructCode,
              purchaseOrgName,
              serviceProviderName,
              instructStatus,
              instructStatusName,
              instructIssueDate,
              instructUpdateDate,
              businessComplatedDate,
            });
            console.log(serviceType);
            if (serviceType == '2') {
              this.serviceTypeShow = serviceType;
              console.log(publicList, 'publicList');
              this.highWayTransportationDataList = publicList;
            }
            if (serviceType == '3') {
              this.serviceTypeShow = serviceType;
              this.consultTransportationDataList = publicList;
            }
            if (serviceType == '4') {
              this.serviceTypeShow = serviceType;
              this.storageTransportationDataList = publicList;
            }
            if (serviceType == '5') {
              this.serviceTypeShow = serviceType;
              this.superviseTransportationDataList = publicList;
            }
            if (serviceType == '6') {
              this.serviceTypeShow = serviceType;
              console.log(data.data[0], 'data.data[0].truckContainer');
              this.railWayTransportationDataList = JSON.parse(data.data[0].truckContainer) || [];
            }
            if (serviceType == '7') {
              this.serviceTypeShow = serviceType;
              this.railWayLoadTransportationDataList = publicList;
            }
          }
        } else {
          this.$message.error(`${data.msg}`);
        }
      },
    },
    mounted() {
      this.currentStatus = this.$route.query?.confirmStatus; // 当前状态

      this._getDetailDataById(this.$route.query?.id);
      this.importDetailsHandler();
    },
    computed: {
      _confirmStatus() {
        return this.$route.query?.confirmStatus;
      },
      _abnormalExpenseFlag() {
        return this.$route.query?.abnormalExpenseFlag;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }
  // .settle-accounts-detail {
  //   height: 79vh;
  //   display: flex;
  //   flex-direction: column;
  //   overflow: auto;
  //   ::v-deep {
  //     .collapse-main-content {
  //       flex-grow: 1;
  //       overflow-y: scroll;
  //       margin-bottom: 20px;
  //       padding-bottom: 0px;
  //     }
  //   }
  // }
</style>
